import { render } from "./permission.vue?vue&type=template&id=249c8312&scoped=true"
import script from "./permission.vue?vue&type=script&lang=js"
export * from "./permission.vue?vue&type=script&lang=js"

import "./permission.vue?vue&type=style&index=0&id=249c8312&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-249c8312"]])

export default __exports__